import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { FormFieldText } from "@/components/FormFields/FormFieldText/FormFieldText";
import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";
import { FieldIdEnum } from "@/lib/types/runtimeTypes";
import { type FormFieldComponentProps } from "@/lib/types/types";

import { displaySSN, unDisplaySSN } from "./SSNHelper";

export const SocialSecurityNumber = ({
  value,
  isErrored,
  onChange,
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps<string>) => {
  const { msg } = useMessage();
  const isFieldHidden = getFieldConfigByFieldId("socialSecurityNumber")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="ssn"
      className="sid-ssn__input"
      refId={FieldIdEnum.socialSecurityNumber}
      value={displaySSN(value)}
      onChange={(newValue) => onChange(unDisplaySSN(newValue))}
      placeholder={placeholder || msg({ id: "ssnPlaceholder" })}
      label={<FormattedHTMLMessage id="ssn" defaultMessage="Social Security Number" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage
            id="errorId.invalidSocialSecurityNumber"
            defaultMessage="Invalid SSN"
          />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      required
      disabled={disabled}
    />
  );
};
